import Vue from 'vue'
import Router from 'vue-router'
import VueHead from 'vue-head'
//const Program = function(resolve) {require(['../components/layout/Program.vue'], resolve)}
import Program from '@/components/layout/Program.vue';

import defaultHead from '../config/defaultHeader'

const MainPage = function(resolve) {require(['../components/layout/MainPage.vue'], resolve)}
const Movie = function(resolve) {require(['../components/layout/Movie.vue'], resolve)}
const Neuigkeiten = function(resolve) {require(['../components/layout/Neuigkeiten.vue'], resolve)}
const Article = function(resolve) {require(['../components/layout/Article.vue'], resolve)}
const Partner = function(resolve) {require(['../components/layout/Partner.vue'], resolve)}
const Presse = function(resolve) {require(['../components/layout/Presse.vue'], resolve)}

const DasKino = function(resolve) {require(['../components/layout/DasKino.vue'], resolve)}
const Wichtiges = function(resolve) {require(['../components/layout/Wichtiges.vue'], resolve)}
const Impressum = function(resolve) {require(['../components/layout/Impressum.vue'], resolve)}
const Datenschutz = function(resolve) {require(['../components/layout/Datenschutz.vue'], resolve)}
const Contact = function(resolve) {require(['../components/layout/Contact.vue'], resolve)}
const Newsletter = function(resolve) {require(['../components/layout/Newsletter.vue'], resolve)}

const PageNotFound = function(resolve) {require(['../components/layout/PageNotFound.vue'], resolve)}

Vue.use(VueHead)
Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
        // , offset: { x: 0, y: 10 }
      }
    }else{
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Main Page',
      component: MainPage,
      menu: false,
      meta: {
        head: defaultHead
      }
    },
    {
      path: '/programm',
      name: 'Programm',
      component: Program,
      menu: 1,
      meta: {
        head: defaultHead
      }
    },
    {
      path: '/programm/:year',
      name: 'Programm für Jahr',
      component: Program,
      menu: false,
      meta: {
        head: defaultHead
      }
    },
    {
      path: '/das-kino',
      name: 'Das Kino',
      component: DasKino,
      menu: 1,
      meta: {
        head: defaultHead
      }
    },
    {
      path: '/wichtiges',
      name: 'Wichtiges',
      component: Wichtiges,
      menu: 1,
      meta: {
        inverted: true,
        head: defaultHead
      }
    },
    {
      path: '/wichtiges/:slug',
      component: Wichtiges,
      menu: false,
      meta: {
        inverted: true,
        head: defaultHead
      }
    },
    {
      path: '/kontakt',
      name: 'Kontakt',
      component: Contact,
      menu: 1,
      meta: {
        head: defaultHead
      }
    },
    {
      path: '/neuigkeiten',
      name: 'Neuigkeiten',
      component: Neuigkeiten,
      menu: false,
      meta: {
        head: defaultHead
      }
    },
    {
      path: '/neuigkeiten/:article',
      component: Article,
      menu: false,
      meta: {
        type: 'page',
        hideMenu: true,
        hideFooter: true,
        head: defaultHead
      }
    },
    {
      path: '/presse',
      name: 'Presse',
      component: Presse,
      menu: 2,
      meta: {
        inverted: false,
        head: defaultHead
      }
    },
    {
      path: '/presse/:article',
      component: Article,
      menu: false,
      meta: {
        type: 'presse',
        hideMenu: true,
        hideFooter: true,
        inverted: false,
        head: defaultHead
      }
    },
    {
      path: '/partner',
      name: 'Partner',
      component: Partner,
      menu: false,
      meta: {
        inverted: true,
        head: defaultHead
      }
    },
    {
      path: '/impressum',
      name: 'Impressum',
      component: Impressum,
      menu: 2,
      meta: {
        inverted: true,
        head: defaultHead
      }
    },
    {
      path: '/datenschutz',
      name: 'Datenschutz',
      component: Datenschutz,
      menu: 2,
      meta: {
        inverted: true,
        head: defaultHead
      }
    },
    {
      path: '/movie/:slug/:day/:month/:year',
      name: 'Movie',
      component: Movie,
      menu: false,
      meta: {
        head: defaultHead
      }
    },
    {
      path: '/newsletter',
      name: 'Newsletter',
      component: Newsletter,
      meta: {
        hideFooter: true
      }
    },
    {
      path: '/404',
      name: '404',
      component: PageNotFound
    },
    { path: "*", redirect: '/404'}
  ]
})

router.afterEach(function (to, from) {

  Vue.prototype.$event.$emit('pageview', {from:from.path, path:to.path});

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js